export default {
  en: {
    newSalePerson: 'New Sales Person',
    salePerson: 'Sales Person',
    firstName: 'First Name',
    lastName: 'Last Name',
    position: 'Position',
    phone: 'Phone',
    mobile: 'Mobile',
    fax: 'Fax',
    email: 'Email',
    signature: 'Signature',
    createSalePerson: 'Create Sales Person',
    cancel: 'Cancel',
    createSalePersonSuccessTitle: 'Success',
    createSalePersonSuccessMessage: 'Create Sales Person Success.',
    remarkImageSize: '* Image size < 1MB',
    imageSizeOverMessage: 'Image size must be smaller than 1MB'
  },
  th: {
    newSalePerson: 'สร้างพนักงานขาย',
    salePerson: 'พนักงานขาย',
    firstName: 'ชื่อ',
    lastName: 'สกุล',
    position: 'ตำแหน่ง',
    phone: 'โทร.',
    mobile: 'มือถือ',
    fax: 'แฟกซ์',
    email: 'อีเมล',
    signature: 'ลายเซ็น',
    createSalePerson: 'เพิ่มพนักงานขาย',
    cancel: 'ยกเลิก',
    createSalePersonSuccessTitle: 'สำเร็จ',
    createSalePersonSuccessMessage: 'สร้างพนักงานขายสำเร็จ',
    remarkImageSize: 'ขนาดรูปภาพ < 1MB',
    imageSizeOverMessage: 'ขนาดรูปภาพต้องไม่เกิน 1MB'
  }
}
